<template>
  <div
    class="w-auto h-auto collapse navbar-collapse max-height-vh-100 h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-collapse navText="儀表板" :to="{ name: 'Dashboard' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        電子商務
      </li>

      <li class="nav-item" v-if="canViewItem('products.view')">
        <sidenav-collapse navText="商品管理" :to="{ name: 'Products' }">
          <template #icon>
            <box3d />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('orders.view')">
        <sidenav-collapse navText="訂單管理" :to="{ name: 'Orders' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('categories.manage')">
        <sidenav-collapse navText="商品分類" :to="{ name: 'Categories' }">
          <template #icon>
            <box3d />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('brands.manage')">
        <sidenav-collapse navText="品牌管理" :to="{ name: 'Brands' }">
          <template #icon>
            <shop />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('tags.manage')">
        <sidenav-collapse navText="標籤管理" :to="{ name: 'Tags' }">
          <template #icon>
            <box3d />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.coupons')">
        <sidenav-collapse navText="折價券管理" :to="{ name: 'Coupons' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.promotions')">
        <sidenav-collapse navText="全站折扣" :to="{ name: 'Promotions' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        訂單與客服
      </li>
      <li class="nav-item" v-if="canViewItem('chat.manage')">
        <sidenav-collapse navText="聊天管理" :to="{ name: 'ChatLobby' }">
          <template #icon>
            <customer-support />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('orders.certifications')">
        <sidenav-collapse navText="認證管理" :to="{ name: 'Certifications' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        內容管理
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.blog_posts')">
        <sidenav-collapse navText="部落格文章" :to="{ name: 'Blog' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.blog_categories')">
        <sidenav-collapse navText="部落格分類" :to="{ name: 'BlogCategories' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.banners')">
        <sidenav-collapse navText="橫幅管理" :to="{ name: 'Banners' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.homepage')">
        <sidenav-collapse navText="首頁管理" :to="{ name: 'HomepageManager' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.newsletter')">
        <sidenav-collapse navText="電子報" :to="{ name: 'Newsletter' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('marketing.homepage')">
        <sidenav-collapse navText="常見問題" :to="{ name: 'Faqs' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('product.inventory')">
        <sidenav-collapse navText="庫存掃描" :to="{ name: 'InventoryScanner' }">
          <template #icon>
            <box3d />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        倉儲管理
      </li>
      <li class="nav-item" v-if="canViewItem('warehouses.manage')">
        <sidenav-collapse navText="倉庫管理" :to="{ name: 'Warehouses' }">
          <template #icon>
            <box3d />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        系統管理
      </li>

      <li class="nav-item" v-if="canViewItem('users.view')">
        <sidenav-collapse navText="會員管理" :to="{ name: 'Users' }">
          <template #icon>
            <customer-support />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('staff.manage')">
        <sidenav-collapse navText="員工管理" :to="{ name: 'StaffManagement' }">
          <template #icon>
            <customer-support />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="canViewItem('dashboard.revenue')">
        <sidenav-collapse navText="營收報表" :to="{ name: 'Revenue' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>

      <li class="nav-item" v-if="canViewItem('system.menu')">
        <sidenav-collapse navText="選單管理" :to="{ name: 'MenuManagement' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('system.payment')">
        <sidenav-collapse navText="金流設定" :to="{ name: 'PaymentSettings' }">
          <template #icon>
            <credit-card />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('system.settings')">
        <sidenav-collapse navText="平台設定" :to="{ name: 'Settings' }">
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('system.settings')">
        <sidenav-collapse navText="語系設定" :to="{ name: 'LanguageSettings' }">
          <template #icon>
            <document />
          </template>
        </sidenav-collapse>
      </li>

      <li
        class="mt-3 mb-2 ms-3 text-xs font-weight-bold text-uppercase opacity-6 text-gold"
      >
        權限控制
      </li>

      <li class="nav-item" v-if="canViewItem('system.roles_manage')">
        <sidenav-collapse navText="角色管理" :to="{ name: 'RoleManagement' }">
          <template #icon>
            <customer-support />
          </template>
        </sidenav-collapse>
      </li>
      <li class="nav-item" v-if="canViewItem('system.permissions_view')">
        <sidenav-collapse
          navText="權限設定"
          :to="{ name: 'PermissionSettings' }"
        >
          <template #icon>
            <settings />
          </template>
        </sidenav-collapse>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer"></div>
</template>
<script>
// Logic remains same
import { canViewSidebarItem, getCurrentUser } from "@/utils/permissions";
import Box3d from "../../components/Icon/Box3d.vue";
import CreditCard from "../../components/Icon/CreditCard.vue";
import CustomerSupport from "../../components/Icon/CustomerSupport.vue";
import Document from "../../components/Icon/Document.vue";
import Settings from "../../components/Icon/Settings.vue";
import Shop from "../../components/Icon/Shop.vue";
import SidenavCollapse from "./SidenavCollapse.vue";

export default {
  name: "SidenavList",
  components: {
    SidenavCollapse,
    Shop,
    CreditCard,
    Box3d,
    CustomerSupport,
    Document,
    Settings,
  },
  data() {
    return { user: null };
  },
  methods: {
    canViewItem(itemName) {
      return canViewSidebarItem(this.user, itemName);
    },
  },
  mounted() {
    this.user = getCurrentUser();
  },
};
</script>
<style scoped>
.text-gold {
  color: #c5a47e;
}
</style>
